/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type IngredientRecipeModalSectionCreateMutationVariables = {|
  ingredient: string,
  recipe: string,
  unity?: ?string,
  qty?: ?string,
  comments?: ?string,
  section?: ?string,
  fraction?: ?string,
|};
export type IngredientRecipeModalSectionCreateMutationResponse = {|
  +recipeIngredientCreate: ?{|
    +recipe: ?{|
      +ingredient: {|
        +id: string,
        +name: string,
      |}
    |}
  |}
|};
export type IngredientRecipeModalSectionCreateMutation = {|
  variables: IngredientRecipeModalSectionCreateMutationVariables,
  response: IngredientRecipeModalSectionCreateMutationResponse,
|};
*/


/*
mutation IngredientRecipeModalSectionCreateMutation(
  $ingredient: String!
  $recipe: ID!
  $unity: ID
  $qty: String
  $comments: String
  $section: ID
  $fraction: String
) {
  recipeIngredientCreate(input: {ingredient: $ingredient, recipe: $recipe, unity: $unity, qty: $qty, comments: $comments, section: $section, fraction: $fraction}) {
    recipe {
      ingredient {
        id
        name
      }
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ingredient",
    "type": "String!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "recipe",
    "type": "ID!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "unity",
    "type": "ID"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "qty",
    "type": "String"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "comments",
    "type": "String"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "section",
    "type": "ID"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "fraction",
    "type": "String"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "comments",
        "variableName": "comments"
      },
      {
        "kind": "Variable",
        "name": "fraction",
        "variableName": "fraction"
      },
      {
        "kind": "Variable",
        "name": "ingredient",
        "variableName": "ingredient"
      },
      {
        "kind": "Variable",
        "name": "qty",
        "variableName": "qty"
      },
      {
        "kind": "Variable",
        "name": "recipe",
        "variableName": "recipe"
      },
      {
        "kind": "Variable",
        "name": "section",
        "variableName": "section"
      },
      {
        "kind": "Variable",
        "name": "unity",
        "variableName": "unity"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "IngredientNode",
  "kind": "LinkedField",
  "name": "ingredient",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IngredientRecipeModalSectionCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RecipeIngredientCreatePayload",
        "kind": "LinkedField",
        "name": "recipeIngredientCreate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RecipeIngredientNode",
            "kind": "LinkedField",
            "name": "recipe",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IngredientRecipeModalSectionCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RecipeIngredientCreatePayload",
        "kind": "LinkedField",
        "name": "recipeIngredientCreate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RecipeIngredientNode",
            "kind": "LinkedField",
            "name": "recipe",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "IngredientRecipeModalSectionCreateMutation",
    "operationKind": "mutation",
    "text": "mutation IngredientRecipeModalSectionCreateMutation(\n  $ingredient: String!\n  $recipe: ID!\n  $unity: ID\n  $qty: String\n  $comments: String\n  $section: ID\n  $fraction: String\n) {\n  recipeIngredientCreate(input: {ingredient: $ingredient, recipe: $recipe, unity: $unity, qty: $qty, comments: $comments, section: $section, fraction: $fraction}) {\n    recipe {\n      ingredient {\n        id\n        name\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '70b5afff5960c01330a068f772feec0f';

module.exports = node;
